import { Model } from "@/models";
import Asset from "@/models/Asset";
import WarehouseItemCustomization from "@/models/WarehouseItemCustomization";

export default class ProductCustomization extends Model {

	static type="productCustomizations";

	uploads: Asset[];
	uuid: string;
	productId: string;
	termsAccepted: boolean;
	warehouseItemCustomizations: WarehouseItemCustomization[];
	updateable: boolean;
}
